/**
 * State shared by region-scoped navigation boundaries.
 *
 * `fullNavigation` lets a URL write reach wouter's underlying location
 * navigation instead of being presented by an in-place surface.
 */
export type NavigationState = { fullNavigation?: boolean };

export const fullNavigationState: NavigationState = { fullNavigation: true };
